export default "__VITE_ASSET__CgT4BCjD__"